<!--
  UnpricedSizesMarker -- flags a Fixed-price product that has selected sizes
  with no price (#3884 gate P2-2). Shoppers cannot order those sizes and
  checkout would 409, so the distributor must see it wherever the product
  appears (card, products table, editor rail) rather than learn it from a
  support call. Renders nothing when `sizes` is empty.

  The count is the text; the title names the sizes. Callers compute `sizes`
  with `unpricedFixedSizes` so every surface applies the same rule.
-->
<template>
  <span
    v-if="sizes.length"
    :data-testid="testid"
    class="unpriced-sizes-marker"
    :title="title"
    >{{ label }}</span
  >
</template>

<script setup>
import { computed } from "vue";
import { unpricedSizesLabel } from "./pricingMode";

const props = defineProps({
  sizes: { type: Array, default: () => [] },
  testid: { type: String, default: "unpriced-sizes-marker" },
});

const label = computed(() => unpricedSizesLabel(props.sizes.length));
const title = computed(
  () =>
    `No price set for ${props.sizes.join(", ")}. Shoppers cannot order ` +
    `${props.sizes.length === 1 ? "this size" : "these sizes"} until you ` +
    "set a price on the Pricing tab.",
);
</script>

<style scoped>
.unpriced-sizes-marker {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  color: #8a4b00;
  background: #fff4e0;
  border: 1px solid #f0c27a;
}
</style>
